import { Routes } from '@angular/router';
import { AdminShellComponent } from './core/layout/admin-shell.component';
import { canActivateAdmin, redirectIfAuthenticated } from './core/guards/auth.guards';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [redirectIfAuthenticated],
    loadComponent: () => import('./pages/auth/login.page').then((m) => m.LoginPage),
  },
  {
    path: '',
    component: AdminShellComponent,
    canActivate: [canActivateAdmin],
    canActivateChild: [canActivateAdmin],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
      },
      {
        path: 'orders',
        loadComponent: () => import('./pages/orders/orders.page').then((m) => m.OrdersPage),
      },
      {
        path: 'promotions',
        loadComponent: () => import('./pages/promotions/promotions.page').then((m) => m.PromotionsPage),
      },
      {
        path: 'coupons',
        loadComponent: () => import('./pages/coupons/coupons.page').then((m) => m.CouponsPage),
      },
      {
        path: 'notifications',
        loadComponent: () => import('./pages/notifications/notifications.page').then((m) => m.NotificationsPage),
      },
      {
        path: 'delivery-agents',
        loadComponent: () => import('./pages/delivery-agents/delivery-agents.page').then((m) => m.DeliveryAgentsPage),
      },
      {
        path: 'delivery-incidents',
        loadComponent: () => import('./pages/delivery-incidents/delivery-incidents.page').then((m) => m.DeliveryIncidentsPage),
      },
      {
        path: 'products',
        loadComponent: () => import('./pages/products/products.page').then((m) => m.ProductsPage),
      },
      {
        path: 'categories',
        loadComponent: () => import('./pages/categories/categories.page').then((m) => m.CategoriesPage),
      },
      {
        path: 'product-categories',
        loadComponent: () => import('./pages/product-categories/product-categories.page').then((m) => m.ProductCategoriesPage),
      },
      {
        path: 'stores',
        loadComponent: () => import('./pages/stores/stores.page').then((m) => m.StoresPage),
      },
      {
        path: 'vendor-reviews',
        loadComponent: () =>
          import('./pages/vendor-reviews/vendor-reviews.page').then((m) => m.VendorReviewsPage),
      },
      {
        path: 'reports',
        loadComponent: () => import('./pages/reports/reports.page').then((m) => m.ReportsPage),
      },
      {
        path: 'grocery-insights',
        loadComponent: () => import('./pages/grocery-insights/grocery-insights.page').then((m) => m.GroceryInsightsPage),
      },
      {
        path: 'earnings',
        loadComponent: () => import('./pages/earnings/earnings.page').then((m) => m.EarningsPage),
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/settings/settings.page').then((m) => m.SettingsPage),
      },
      {
        path: 'audit-logs',
        loadComponent: () => import('./pages/audit-logs/audit-logs.page').then((m) => m.AuditLogsPage),
      },
      {
        path: 'settings/service-zone',
        loadComponent: () => import('./pages/settings/service-zone.page').then((m) => m.ServiceZonePage),
      },
      {
        path: 'settings/zone-hours',
        loadComponent: () => import('./pages/settings/zone-hours.page').then((m) => m.ZoneHoursPage),
      },
      {
        path: 'settings/tax',
        loadComponent: () => import('./pages/tax-settings/tax-settings.page').then((m) => m.TaxSettingsPage),
      },
      {
        path: 'settings/delivery-fee',
        loadComponent: () => import('./pages/delivery-fee-settings/delivery-fee-settings.page').then((m) => m.DeliveryFeeSettingsPage),
      },
      {
        path: 'settings/delivery-cod-qr',
        loadComponent: () =>
          import('./pages/delivery-cod-qr-settings/delivery-cod-qr-settings.page').then(
            (m) => m.DeliveryCodQrSettingsPage,
          ),
      },
      {
        path: 'settings/order',
        loadComponent: () => import('./pages/order-settings/order-settings.page').then((m) => m.OrderSettingsPage),
      },
      {
        path: 'settings/support-contact',
        loadComponent: () =>
          import('./pages/support-contact-settings/support-contact-settings.page').then(
            (m) => m.SupportContactSettingsPage,
          ),
      },
      {
        path: 'settings/pos-location',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'settings/pos-locations',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      // POS location pages are temporarily disabled; requests redirect to dashboard.
      // {
      //   path: 'settings/pos-location',
      //   redirectTo: 'settings/pos-locations',
      //   pathMatch: 'full',
      // },
      // {
      //   path: 'settings/pos-locations',
      //   loadComponent: () => import('./pages/pos-locations/pos-locations.page').then((m) => m.PosLocationsPage),
      // },
      {
        path: 'users',
        loadComponent: () => import('./pages/users/users.page').then((m) => m.UsersPage),
      },
      {
        path: 'crash-reports',
        loadComponent: () => import('./pages/crash-reports/crash-reports.page').then((m) => m.CrashReportsPage),
      },
      {
        path: 'parcel/dashboard',
        loadComponent: () => import('./pages/parcel/parcel-dashboard.page').then((m) => m.ParcelDashboardPage),
      },
      {
        path: 'parcel/pricing',
        loadComponent: () => import('./pages/parcel/parcel-pricing.page').then((m) => m.ParcelPricingPage),
      },
      {
        path: 'parcel/drivers',
        loadComponent: () => import('./pages/parcel/parcel-drivers.page').then((m) => m.ParcelDriversPage),
      },
      {
        path: 'parcel/reports',
        loadComponent: () => import('./pages/parcel/parcel-reports.page').then((m) => m.ParcelReportsPage),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: '**',
        redirectTo: 'dashboard',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
